/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { html, nothing } from 'lit';
// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { ConsentGroup, ConsentType } from '@mfe/types/common';
import { cancelMicrofrontend } from '@mfe/store/consents';
import store from '@mfe/store';
import type TefComsConsentGroup from '../../tef-coms-group';
import { filterPredicator } from '../util';

export const clickTextTemplate = (
  checkBoxId: string,
  comsConsentGroup: TefComsConsentGroup,
) => html`
    <div class="form-group-checkbox">
        <input id=${checkBoxId} type="checkbox" @click=${comsConsentGroup.oneclickAction.bind(comsConsentGroup)} />
        <label for=${checkBoxId}>
          ${unsafeHTML(comsConsentGroup.consentGroup.text)}
        </label>
      </div>
    `;

export const clickConsentsContainerTemplate = (
  stylecontext: string,
  comsConsentGroup: TefComsConsentGroup,
  collapsibleOpenGroupName: string,
) => {
  const { oneclickCollapsible } = comsConsentGroup.consentGroup;
  return html`
    <tef-coms-collapsible
        once
        cloak
        context="${stylecontext}"
        ?is-open="${comsConsentGroup.groupName === collapsibleOpenGroupName}"
      >
        <div slot="title">
          ${oneclickCollapsible ? unsafeHTML(oneclickCollapsible)
    : 'Wenn ich einzelne Kontaktkanäle und Verarbeitungsvorgänge von meiner '
                  + 'Auswahl ausschließen möchte, kann ich hier gesonderte Einwilligungen erteilen.'}
        </div>
        <div slot="content">
          ${comsConsentGroup.groupConsents('group')}
        </div>
      </tef-coms-collapsible>
    `;
};

export const groupConsentsTemplate = (
  comsConsentGroup: TefComsConsentGroup,
) => {
  const { consents, required } = comsConsentGroup.consentGroup;
  return html`
    <ul class="list">
      ${consents /* eslint-disable indent, @typescript-eslint/indent */
        .filter(filterPredicator)
        .map(
          (consent) => html`
            ${consent.hintBefore ? html`<li class="coms-hint-before">${unsafeHTML(consent.hintBefore)}</li>` : nothing}
            <li class="coms-consent">
              <tef-coms-consent .consent=${consent} ?required=${required}></tef-coms-consent>
            </li>
            ${consent.hintAfter
              ? html`<li class="coms-hint-after">${unsafeHTML(consent.hintAfter)}</li>`
              : nothing
            }`,
        )/* eslint-enable indent, @typescript-eslint/indent */}
    </ul>
  `;
};

export const withdrawalTemplate = (
  comsConsentGroup: TefComsConsentGroup,
  checkboxId: string,
) => {
  const { denyall } = comsConsentGroup.consentGroup;
  return html`
    <div class="form-row">
        ${/* eslint-disable indent, @typescript-eslint/indent */
        html`
          <div class="form-group-checkbox">
            <input
              id=${checkboxId}
              type="checkbox"
              .checked=${comsConsentGroup.noConsentSet}
              @click=${comsConsentGroup.denyAction.bind(comsConsentGroup)}
            />
            <label for=${checkboxId}>
              ${unsafeHTML(denyall.toString())}
            </label>
          </div>
        `}
      </div>
    `;
  };

  export const groupViewTemplate = (
    comsConsentGroup: TefComsConsentGroup,
    consentGroupsView: ConsentGroup[],
    filteredConsents: ConsentType[],
    stylecontext: string,
  ) => {
    const {
        header, text, footer, denyallView,
    } = consentGroupsView[comsConsentGroup.groupIndex];

    // Do we need a "Zurück" button?
    let backButtonHtml = html`${nothing}`;
    if (comsConsentGroup.mode.includes('buttons:cancel')) {
      backButtonHtml = html`
        <button @click=${() => { store.dispatch(cancelMicrofrontend()); }} class="button button-border">Zurück</button>
      `;
    }

    return html`
      <h4 class="typography-display--4">
        ${unsafeHTML(header)}
      </h4>
      <p>
        ${unsafeHTML(text)}
      </p>
      ${(filteredConsents.length === 0 && denyallView) ? html`
        <div class="coms-ocw">${unsafeHTML(denyallView)}</div>
        ` : html`
        <tef-coms-collapsible-group context="${stylecontext}">
          ${filteredConsents.map((consent) => html`
            <tef-coms-collapsible context="${stylecontext}">
              <div slot="title">
                ${unsafeHTML(consent.shortInfo)}
              </div>
              <div slot="content">
                  <tef-coms-consent .mode=${comsConsentGroup.mode} .consent=${consent}></tef-coms-consent>
              </div>
            </tef-coms-collapsible>
          `)}
        </tef-coms-collapsible-group>
      `}
      ${footer ? html`
        <p>
          ${unsafeHTML(footer)}
        </p>
      ` : nothing}

      <div class="form-row form-row--buttons section-buttons">
        ${backButtonHtml}
        <button @click=${comsConsentGroup.openGroupForEdit.bind(comsConsentGroup)} class="button button-default" data-test-id="update">Ändern</button>
      </div>
    `;
  };

  export const groupTemplate = (comsConsentGroup: TefComsConsentGroup) => {
    const { header, footer, oneclick: oneclick1 } = comsConsentGroup.consentGroup;
       return html`
       <h4 class="typography-display--4">
         ${unsafeHTML(header)}
       </h4>
       <p>
         ${oneclick1 ? comsConsentGroup.groupOneclickText : comsConsentGroup.groupText}
       </p>
       <div>
         ${oneclick1 ? comsConsentGroup.groupOneclickConsentsContainer : comsConsentGroup.groupConsents()}
       </div>

       ${footer ? html`
         <p>
           ${unsafeHTML(footer)}
         </p>
       ` : nothing}

       ${comsConsentGroup.withdrawal}
     `;
   };
